import { getSampling } from "../config/load";
import type { Matcher } from "./index";
import type { InstantConfigGroup } from "../config/types";
import type { BucketingProvider } from "../bucketing";

/**
 * This code is deprecated and scheduled for removal once the transition to buckets is fully complete.
 * @deprecated
 */
export const samplingMatcher = (
  samplingProvider: BucketingProvider,
): Matcher => {
  return (group: InstantConfigGroup) => {
    const sampling = getSampling(group);
    if (sampling === null) {
      return true;
    }

    const randomValue: number = Math.round(samplingProvider());
    const thresholdValue: number = Math.round(sampling!);

    return randomValue < thresholdValue;
  };
};
